import {
  OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubject,
  OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubjectList,
  OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode,
  OrderCargoOrderDetailsResponseItemCargoOrderRideSeq,
  OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNodeSet,
  OrderCargoOrderDetailsResponseItemCargoOrderRide,
  OrderCargoOrderDetailsResponseItemCargoOrderCargoSource,
  OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceType,
  OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceElement,
  OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatchCargoCompany,
  OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatch,
  OrderCargoOrderDetailsResponseItemCargoOrderDispatcher,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntryDriver,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntry,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItem,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRide,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrder,
  OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrder,
  OrderCargoOrderDetailsResponseItemCargoOrder,
  OrderCargoOrderDetailsResponseItemPassengerDataPassengerAddressData,
  OrderCargoOrderDetailsResponseItemPassengerDataPassenger,
  OrderCargoOrderDetailsResponseItemPassenger,
  OrderCargoOrderDetailsResponseItemDriver,
  OrderCargoOrderDetailsResponseItemNodeExclusion,
  OrderCargoOrderDetailsResponseItem,
} from "../../../../api/raily/order/cargo-order/details/order-cargo-order-details.response";
import SourceType from "../../../../types/source-type";
import OrderCargoOrderDetails, {
  OrderCargoOrderDetailsCargoOrder,
  OrderCargoOrderDetailsCargoOrderCargoSource,
  OrderCargoOrderDetailsCargoOrderCargoSourceElement,
  OrderCargoOrderDetailsCargoOrderDispatcher,
  OrderCargoOrderDetailsCargoOrderDispatcherDispatch,
  OrderCargoOrderDetailsCargoOrderDispatcherDispatchCargoCompany,
  OrderCargoOrderDetailsCargoOrderRide,
  OrderCargoOrderDetailsCargoOrderRideMetaCargoSubject,
  OrderCargoOrderDetailsCargoOrderRideMetaCargoSubjectList,
  OrderCargoOrderDetailsCargoOrderRideSeq,
  OrderCargoOrderDetailsCargoOrderRideSeqNode,
  OrderCargoOrderDetailsCargoOrderRideSeqNodeSet,
  OrderCargoOrderDetailsCargoOrderTransportingOrder,
  OrderCargoOrderDetailsCargoOrderTransportingOrderCreatePlanEntry,
  OrderCargoOrderDetailsCargoOrderTransportingOrderCreatePlanEntryDriver,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrder,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRide,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItem,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject,
  OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList,
  OrderCargoOrderDetailsDriver,
  OrderCargoOrderDetailsNodeExclusion,
  OrderCargoOrderDetailsPassenger,
  OrderCargoOrderDetailsPassengerDataPassenger,
  OrderCargoOrderDetailsPassengerDataPassengerAddressData,
} from "./order-cargo-order-details";

const createCargoSubject = (
  subject: OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubject,
): OrderCargoOrderDetailsCargoOrderRideMetaCargoSubject => {
  return {
    uuid: subject.id,
  };
};

const createCargoSubjectList = (
  subjectList: OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubjectList,
): OrderCargoOrderDetailsCargoOrderRideMetaCargoSubjectList => {
  return {
    subjects: subjectList.subjects.map(createCargoSubject),
  };
};

const createRideSeqNode = (
  node: OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode,
): OrderCargoOrderDetailsCargoOrderRideSeqNode => {
  return {
    displayName: node.displayName,
    haltingTime: node.haltingTime,
    lat: node.lat,
    lon: node.lon,
    meta: {
      uuid: node.meta.id,
      cargoEnter: createCargoSubjectList(node.meta.cargoEnter),
      cargoExit: createCargoSubjectList(node.meta.cargoExit),
    },
    time: node.time,
    apartment: node.apartment,
    houseNo: node.houseNo,
    street: node.street,
    town: node.town,
    zipCode: node.zipCode,
  };
};

const createRideSeq = (
  seq: OrderCargoOrderDetailsResponseItemCargoOrderRideSeq,
): OrderCargoOrderDetailsCargoOrderRideSeq[] => {
  const sequence: OrderCargoOrderDetailsCargoOrderRideSeq[] = [];

  seq.forEach((group) => {
    const nodeSetCast =
      group as OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNodeSet;

    if (!!nodeSetCast.seq) {
      const nodes: OrderCargoOrderDetailsCargoOrderRideSeqNode[] = [];

      nodeSetCast.seq.forEach((node) => {
        nodes.push(createRideSeqNode(node));
      });

      const nodeSet: OrderCargoOrderDetailsCargoOrderRideSeqNodeSet = {
        seq: nodes,
        meta: {
          uuid: nodeSetCast.meta.id,
        },
        sequenceOrder: "ANY",
      };

      sequence.push(nodeSet);
    } else {
      const nodeCast =
        group as OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode;

      sequence.push(createRideSeqNode(nodeCast));
    }
  });

  return sequence;
};

const createRide = (
  ride: OrderCargoOrderDetailsResponseItemCargoOrderRide,
): OrderCargoOrderDetailsCargoOrderRide => {
  return {
    meta: {
      uuid: ride.meta.id,
    },
    seq: createRideSeq(ride.seq),
    sequenceOrder: "STRICT",
  };
};

const createItemSourceListElementSource = (
  cargoItemSource: OrderCargoOrderDetailsResponseItemCargoOrderCargoSource,
): OrderCargoOrderDetailsCargoOrderCargoSource => {
  if (
    cargoItemSource.sourceType ==
    OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceType.EXTERNAL
  ) {
    return {
      sourceType: SourceType.EXTERNAL,
      firstName: cargoItemSource.firstName,
      lastName: cargoItemSource.lastName,
      phoneNo: cargoItemSource.phoneNo,
      dispatchName: cargoItemSource.dispatchName,
      externalId: cargoItemSource.externalId,
    };
  } else {
    return {
      sourceType: SourceType.INTERNAL,
      externalId: cargoItemSource.externalId,
    };
  }
};

const createItemSourceListElement = (
  element: OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceElement,
): OrderCargoOrderDetailsCargoOrderCargoSourceElement => {
  return {
    cargoSubjectUuid: element.cargoSubjectId,
    cargoItemSource: createItemSourceListElementSource(element.cargoItemSource),
  };
};

const createItemSourceList = (
  cargoItemsSourceList: OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceElement[],
): OrderCargoOrderDetailsCargoOrderCargoSourceElement[] => {
  return cargoItemsSourceList.map(createItemSourceListElement);
};

const createCargoOrderDispatcherDispatchCargoCompany = (
  cargoCompany: OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatchCargoCompany,
): OrderCargoOrderDetailsCargoOrderDispatcherDispatchCargoCompany => {
  return {
    id: cargoCompany.id,
  };
};

const createCargoOrderDispatcherDispatch = (
  dispatch: OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatch,
): OrderCargoOrderDetailsCargoOrderDispatcherDispatch => {
  return {
    cargoCompany: createCargoOrderDispatcherDispatchCargoCompany(
      dispatch.cargoCompany,
    ),
  };
};

const createCargoOrderDispatcher = (
  dispatcher: OrderCargoOrderDetailsResponseItemCargoOrderDispatcher,
): OrderCargoOrderDetailsCargoOrderDispatcher => {
  return {
    dispatch: createCargoOrderDispatcherDispatch(dispatcher.dispatch),
  };
};

const createCargoOrderTransportingOrderPlanEntryDriver = (
  driver: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntryDriver,
): OrderCargoOrderDetailsCargoOrderTransportingOrderCreatePlanEntryDriver => {
  return {
    id: driver.id,
    firstName: driver.firstName,
    lastName: driver.lastName,
    mobilePrimary: driver.mobilePrimary,
    mobilePrimaryPrefix: driver.mobilePrimaryPrefix,
  };
};

const createCargoOrderTransportingOrderPlanEntry = (
  planEntry: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntry,
): OrderCargoOrderDetailsCargoOrderTransportingOrderCreatePlanEntry => {
  return {
    driver: createCargoOrderTransportingOrderPlanEntryDriver(planEntry.driver),
  };
};

const createCargoOrderTransportingOrderPlanEntryEntries = (
  planEntryEntries: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntry[],
): OrderCargoOrderDetailsCargoOrderTransportingOrderCreatePlanEntry[] => {
  return planEntryEntries.map(createCargoOrderTransportingOrderPlanEntry);
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject = (
  subject: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject => {
  return {
    id: subject.id,
  };
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjects = (
  subjects: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject[],
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject[] => {
  return subjects.map(
    createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject,
  );
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList = (
  subjectList: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList => {
  return {
    subjects:
      createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjects(
        subjectList.subjects,
      ),
  };
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta = (
  meta: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta => {
  return {
    cargoEnter:
      createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList(
        meta.cargoEnter,
      ),
    cargoExit:
      createCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList(
        meta.cargoExit,
      ),
    estimatedTime: meta.estimatedTime,
  };
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItem = (
  seqItem: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItem,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItem => {
  return {
    displayName: seqItem.displayName,
    haltingTime: seqItem.haltingTime,
    lat: seqItem.lat,
    lon: seqItem.lon,
    meta: createCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta(
      seqItem.meta,
    ),
    time: seqItem.time,
  };
};

const createCargoOrderTransportingOrderSolvedOrderRideSeqItems = (
  seqItems: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItem[],
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRideSeqItem[] => {
  return seqItems.map(createCargoOrderTransportingOrderSolvedOrderRideSeqItem);
};

const createCargoOrderTransportingOrderSolvedOrderRide = (
  ride: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRide,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrderRide => {
  return {
    seq: createCargoOrderTransportingOrderSolvedOrderRideSeqItems(ride.seq),
  };
};

const createCargoOrderTransportingOrderSolvedOrder = (
  solvedOrder: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrder | null,
): OrderCargoOrderDetailsCargoOrderTransportingOrderSolvedOrder | null => {
  if (!solvedOrder) {
    return null;
  }

  return {
    ride: createCargoOrderTransportingOrderSolvedOrderRide(solvedOrder.ride),
  };
};

const createCargoOrderTransportingOrder = (
  transportingOrders: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrder,
): OrderCargoOrderDetailsCargoOrderTransportingOrder => {
  return {
    createPlanEntryEntries: createCargoOrderTransportingOrderPlanEntryEntries(
      transportingOrders.createPlanEntryEntries,
    ),
    solvedOrder: createCargoOrderTransportingOrderSolvedOrder(
      transportingOrders.solvedOrder,
    ),
  };
};

const createCargoOrderTransportingOrders = (
  transportingOrders: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrder[],
): OrderCargoOrderDetailsCargoOrderTransportingOrder[] => {
  return transportingOrders.map(createCargoOrderTransportingOrder);
};

const createCargoOrder = (
  cargoOrder: OrderCargoOrderDetailsResponseItemCargoOrder,
): OrderCargoOrderDetailsCargoOrder => {
  return {
    ride: createRide(cargoOrder.ride),
    cargoItemsSourceList: createItemSourceList(cargoOrder.cargoItemsSourceList),
    dispatcher: createCargoOrderDispatcher(cargoOrder.dispatcher),
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
    transportingOrders: createCargoOrderTransportingOrders(
      cargoOrder.transportingOrders,
    ),
  };
};

const createPassengerPassengerAddress = (
  address: OrderCargoOrderDetailsResponseItemPassengerDataPassengerAddressData,
): OrderCargoOrderDetailsPassengerDataPassengerAddressData => {
  return {
    displayName: address.displayName,
    id: address.id,
    lat: address.lat,
    lon: address.lon,
    apartment: address.apartment,
    houseNo: address.houseNo,
    street: address.street,
    town: address.town,
    zipcode: address.zipcode,
  };
};

const createPassengerPassengerAddresses = (
  addresses: OrderCargoOrderDetailsResponseItemPassengerDataPassengerAddressData[],
): OrderCargoOrderDetailsPassengerDataPassengerAddressData[] => {
  return addresses.map(createPassengerPassengerAddress);
};

const createPassengerPassenger = (
  passenger: OrderCargoOrderDetailsResponseItemPassengerDataPassenger,
): OrderCargoOrderDetailsPassengerDataPassenger => {
  return {
    addresses: createPassengerPassengerAddresses(passenger.addresses),
  };
};

const createPassenger = (
  passenger: OrderCargoOrderDetailsResponseItemPassenger,
): OrderCargoOrderDetailsPassenger => {
  return {
    firstName: passenger.firstName,
    lastName: passenger.lastName,
    uuid: passenger.id,
    passenger: createPassengerPassenger(passenger.passenger),
  };
};

const createPassengers = (
  passengers: OrderCargoOrderDetailsResponseItemPassenger[],
): OrderCargoOrderDetailsPassenger[] => {
  return passengers.map(createPassenger);
};

const createDriver = (
  driver: OrderCargoOrderDetailsResponseItemDriver,
): OrderCargoOrderDetailsDriver => {
  return {
    firstName: driver.firstName,
    id: driver.id,
    lastName: driver.lastName,
    mobilePrimary: driver.mobilePrimary,
    mobilePrimaryPrefix: driver.mobilePrimaryPrefix,
  };
};

const createDrivers = (
  passengers: OrderCargoOrderDetailsResponseItemDriver[],
): OrderCargoOrderDetailsDriver[] => {
  return passengers.map(createDriver);
};

const createNodeExclusion = (
  exclusion: OrderCargoOrderDetailsResponseItemNodeExclusion,
): OrderCargoOrderDetailsNodeExclusion => {
  return {
    excludeApproaching: exclusion.excludeApproaching,
    excludeInside: exclusion.excludeInside,
    excludeReturning: exclusion.excludeReturning,
  };
};

const create = (
  responseItem: OrderCargoOrderDetailsResponseItem,
): OrderCargoOrderDetails => {
  return {
    passengers: createPassengers(responseItem.passengers),
    cargoOrder: createCargoOrder(responseItem.cargoOrder),
    forceAllowToll: responseItem.forceAllowToll,
    id: responseItem.id,
    nodeExclusion: createNodeExclusion(responseItem.nodeExclusion),
    drivers: createDrivers(responseItem.drivers),
  };
};

const cargoOrderDetailsFactory = { create };

export default cargoOrderDetailsFactory;
